import { initialize } from 'vue-ld';
import { useStore } from 'vuex';

export default defineNuxtPlugin(async ({ provide }) => {
  const store = useStore();

  const loadLaunchDarkly = async () => {
    const clientId = useRuntimeConfig().public.APPTEGY_OIDC_CLIENT_ID || store.state.clientId;
    const ldClientKey = useRuntimeConfig().public.LAUNCH_DARKLY_KEY;
    try {
      if (ldClientKey && clientId) {
        const $ld = initialize({
          clientSideId: ldClientKey,
          user: {
            key: 'cms-public',
            custom: {
              client_id: clientId && `urn:apptegy:global:sso:client:${clientId}`,
              entity_type: 'staff',
            },
          },
        });
        await $ld.ldClient.waitUntilReady();
        provide('ld', $ld);
      } else {
        provide('ld', { flags: {} });
      }
    } catch (error) {
      console.error(error);
    }
  };
  await loadLaunchDarkly();
});
